import { Users as UsersIcon } from 'lucide-react';
import { PageHeader } from '../../ui';

export function Users() {
  return (
    <div className="max-w-4xl mx-auto">
      <PageHeader
        className="mb-6"
        title="User Access"
        icon={UsersIcon}
        subtitle="Manage which users can access each protocol"
      />

      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center dark:bg-gray-800 dark:border-gray-700">
        <UsersIcon size={48} className="mx-auto text-gray-300 mb-4 dark:text-gray-600" />
        <h3 className="text-lg font-medium text-gray-900 mb-2 dark:text-gray-100">User access management coming soon</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          You'll be able to assign users to protocols and manage their access levels here.
        </p>
      </div>
    </div>
  );
}
